export default __webpack_public_path__ + "static/media/autofact-logo-new.785d99cf.svg";